/****************************************************
* Module Name:  UserProcessMasterProxy.js
* Project:      Pansuriya Impex Sales & Manufacturing
* Owner:        info@pansuriyaimpex.com
*
* Copyright (c) Pansuriya Impex
* All rights reserved.
****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class UserProcessMasterProxy {
    static GetAllUserProcess = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mfguserprocess",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static createOrUpdateUserProcess = (userid, processid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/mfguserprocess/${userid}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(processid),
            "application/json",
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}